'use client';
import React, { createContext, useState, useContext, useCallback } from 'react';
import { ManageAccountModal } from '@/components/MyAccount/ManageAccount/ManageAccountModal';
import SubscribeDrawer from '@/components/Newsletters/SubscribeDrawer';

export enum PopupTypes {
  PersonalDetails = 'personal_details',
  NewsletterSubscription = 'newsletter_subscription'
}

interface PopupsContextProps {
  openPopup: (popup: PopupTypes) => void;
}

const PopupsContext = createContext<PopupsContextProps>({
  openPopup: () => null
});

export const PopupsProvider = ({ children }: { children: React.ReactNode }) => {
  const [currentPopup, setCurrentPopup] = useState<PopupTypes | null>(null);

  const openPopup = useCallback((popup: PopupTypes) => {
    setCurrentPopup((prev) => {
      if (!prev) return popup;
      return prev;
    });
  }, []);

  const closePopup = useCallback((popup: PopupTypes) => {
    setCurrentPopup((prev) => {
      if (prev === popup) return null;
      return prev;
    });
  }, []);

  return (
    <PopupsContext.Provider
      value={{
        openPopup
      }}
    >
      {children}
      <SubscribeDrawer
        open={currentPopup === PopupTypes.NewsletterSubscription}
        onClose={() => closePopup(PopupTypes.NewsletterSubscription)}
      />
      <ManageAccountModal
        open={currentPopup === PopupTypes.PersonalDetails}
        onClose={() => closePopup(PopupTypes.PersonalDetails)}
      />
    </PopupsContext.Provider>
  );
};

export const usePopups = () => {
  const context = useContext(PopupsContext);
  if (!context) {
    throw new Error('usePopups must be used within a PopupsProvider');
  }
  return context;
};
